export default class ReceiverLicenseChangeReceipt {
  constructor (options = {}) {
    this.model = 'ReceiverLicenseChangeReceipt'

    this.id = options.id
    this.receiver_id = options.receiver_id
    this.approved_licenses_id = options.approved_licenses_id
    this.is_dismissed = options.is_dismissed

    // Auditing
    this.dismissed_by = options.dismissed_by
    this.dismissed_at = options.dismissed_at
    this.created_at = options.created_at
    this.updated_at = options.updated_at

    // Associations
    if (options.approved_licenses_record) this.approved_licenses_record = options.approved_licenses_record
  }
}
